const BOT_USER_AGENT_REGEX =
  /(googlebot|googleother|adsbot|apis-google|mediapartners-google|bingbot|bingpreview|slurp|duckduckbot|yandex|baiduspider|sogou|exabot|ia_archiver|facebookexternalhit|pinterest|twitterbot|linkedinbot|discordbot|whatsapp|telegrambot|linebot|vkshare|embedly|quora|crawler|spider)/i;

export function isBotUserAgent(userAgent: string | null | undefined): boolean {
  return BOT_USER_AGENT_REGEX.test(userAgent ?? '');
}
